import { motion, AnimatePresence } from 'framer-motion';
import { MDXRemote, type MDXRemoteSerializeResult } from 'next-mdx-remote';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
interface Props {
  text: MDXRemoteSerializeResult;
}
const EXPANDED_HEIGHT = 48;
export function CategoryDescription(props: Props) {
  const {
    t
  } = useTranslation('gcss');
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [showExpandButton, setShowExpandButton] = useState<boolean>(true);
  const descriptionElement = useRef<HTMLDivElement>(null);
  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };
  useEffect(() => {
    if (descriptionElement.current) {
      setShowExpandButton(descriptionElement.current.offsetHeight > EXPANDED_HEIGHT);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [descriptionElement.current]);
  return <div>
			<AnimatePresence initial={false}>
				<motion.div style={showExpandButton ? {
        overflow: 'hidden',
        cursor: 'pointer'
      } : undefined} initial={{
        height: EXPANDED_HEIGHT
      }} animate={{
        height: isExpanded ? 'auto' : EXPANDED_HEIGHT
      }} transition={{
        duration: 0.5
      }}>
					<div ref={descriptionElement}>
						<MDXRemote {...props.text} />
					</div>
				</motion.div>
			</AnimatePresence>
			{showExpandButton && <button className="text-blue-500 underline" onClick={toggleExpanded}>
					{isExpanded ? t('category.showLess') : t('category.showMore')}
				</button>}
		</div>;
}